module.exports = __webpack_public_path__ + "static/media/portfolio-6.5e22c151.jpg";